import type { ListResult } from "@prolarus/shared";
import { tryList } from "./_shared";

export interface GroupModuleRow {
  licensed_module_id: string;
  module_name: string;
  module_code: string;
  assigned_at: string;
}

// Read-only — mirrors the prior groupModuleService surface.
export const groupModuleService = {
  listModules(
    groupId: string,
    _companyId: string,
  ): Promise<ListResult<GroupModuleRow>> {
    return tryList<GroupModuleRow>(
      `/api/groups/${encodeURIComponent(groupId)}/modules`,
    );
  },
};
